import React, { useEffect, useState } from 'react'

import { useNavigate, useSearchParams } from 'react-router-dom';

import { useAppContext } from 'app/AppContext';
import FForm, { useFormApi } from 'components/form';
import FormContent from 'components/form/FormContent';
import FormRow from 'components/form/FormRow';
import TextInput from 'components/form/input/TextInput';
import { useEntity, fetchArray } from 'entity';
import Perfil from 'entity/Perfil';
import useNotification from 'notification';
import SelectButtonInput from 'components/form/input/SelectButtonInput';

export default function PerfilForm() {
    const { useSetTitle, setActionsView } = useAppContext();

    const [initialValues, setInitialValues] = useState({})
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { showSuccess, showWarning } = useNotification()
    const form = useFormApi();
    const entity = useEntity(Perfil, searchParams.get("uid"));

    useEffect(() => {
        const actions = [
            // {
            //     uid: "novoForm",
            //     text: "Novo",
            //     iconName: "Add",
            //     sequence: "10",
            //     action: () => {
            //         console.log('form', form)

            //         navigate("/perfil");
            //     },
            // },
            {
                uid: "salvarForm",
                text: "Salvar",
                iconName: "Check",
                sequence: "20",
                action: () => {
                    form.submit();
                },
            },
            {
                uid: "sairForm",
                text: "Sair",
                iconName: "Close",
                sequence: "999999",
                action: () => {
                    // TODO: exibir diálogo de confirmação se o form estiver dirty.
                    navigate("/consulta-perfil");
                },
            },
        ];

        setActionsView(actions);

        return () => {
            setActionsView([]);
        };
    }, [form, navigate, setActionsView]);

    useSetTitle("Perfil");

    async function handleSubmit(values) {
        // console.log(values)

        let query = await Perfil.where("email", "==", values.email);
        const perfil = await fetchArray(query.get());
        console.log('perfil[0]', perfil[0])
        console.log('values', values)
        // email já cadastrado
        if (perfil.length && perfil[0].uid !== values.uid) {
            // console.log("query com item", perfil)
            showWarning("Email já cadastrado")
        } else {
            // console.log("query vazia", perfil)

            entity.update(values);

            entity.save().then(() => {
                // console.log('salvou')
                showSuccess("Salvo com Sucesso")
            })
        }
    }
    useEffect(() => {
        setInitialValues(entity.data)
    }, [entity.data])

    return (
        <FForm formApi={form} onSubmit={handleSubmit} initialValues={initialValues} sx={{ mt: 1 }}>
            <FormContent sx={{ m: 1 }}>
                <FormRow>
                    <TextInput name="name" label="Nome" required />
                    <TextInput type="email" name="email" label="E-mail" required />
                </FormRow>
                <FormRow>
                    <SelectButtonInput
                        name="tipoPerfil"
                        label="Perfil"
                        options={["admin", "colaborador"]}
                        optionsToString={["ADMINISTRADOR", "COLABORADOR"]}
                        required
                    />
                </FormRow>
            </FormContent>
        </FForm>
    )
}
